<template>
  <div>
    <v-btn
      v-if="!filtersStore.hasUnsavedFilters"
      text
      block
      depressed
      color="primary"
      class="bg-primary"
      @click="$emit('click:close')"
    >
      {{ t('Закрыть', options) }}
    </v-btn>
    <v-btn
      v-else-if="!countLpu && !loading"
      block
      depressed
      disabled
      color="primary"
    >
      {{ t('Не найдено', options) }}
    </v-btn>
    <v-btn
      v-else
      block
      depressed
      type="submit"
      color="primary"
      data-filters-yandex-goals="filter-lpu-list-result-show"
      :loading="loading"
      @click="$emit('click:submit')"
    >
      <template v-if="countLpu">
        {{ t('Показать', options) }}
        {{ countLpu.toLocaleString('ru-RU') }}
        {{ t(getNounCase(countLpu, ['клинику', 'клиники', 'клиник']), options) }}
      </template>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { getNounCase } from 'www/utils'
import { computed, ref, watch } from 'vue'
import I18NextVue from 'i18next'
import apiLpuList from 'www/vue_components/common/TheFilters/lpu/api/apiLpuList'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'

const emit = defineEmits(['input', 'click:close', 'click:submit'])

const props = defineProps<{
  value?: boolean
  active: boolean,
  triggerRequest?: any
}>()

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

const requests = ref(0)
const loading = computed(() => Boolean(requests.value))
const countLpu = ref<number>()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const loadLpuCount = async () => {
  if (!filtersStore.hasUnsavedFilters || !props.active) {
    return
  }

  requests.value++

  try {
    const {
      place,
      lpuType,
      doctorSpeciality,
      isHighRating,
      isClubAppointment,
      isOnlineAppointment,
      timeWork,
    } = filtersStore.unsavedFilters

    const newTown = place?.townRedirect
    const hasPlace = place && !newTown
    const targetTown = place?.isMetro ? commonStore.town.regionalCenter : commonStore.town

    const { data } = await apiLpuList.getCount({
      high_rating: isHighRating,
      club_appointment: isClubAppointment,
      online_appointment: isOnlineAppointment,
      lpu_type_id: lpuType?.id,
      speciality_id: doctorSpeciality?.id,
      page_type: lpuType ? 'lpu_list' : 'town_lpu',
      town_id: newTown?.id || targetTown.id,
      metro_id: hasPlace && place.isMetro ? place.id : undefined,
      district_id: hasPlace && !place.isMetro ? place.id : undefined,
      h24: timeWork.type === '24_7' || undefined,
      now: timeWork.type === 'open_now' || undefined,
      ...(timeWork.type === 'custom' && {
        weekday: timeWork.weekday,
        work_time_from: timeWork.time.from,
        work_time_to: timeWork.time.to,
      }),
    })

    countLpu.value = data.count
  } catch {
    countLpu.value = undefined
  } finally {
    requests.value--
  }
}

if (props.triggerRequest !== undefined) {
  watch(() => props.triggerRequest, loadLpuCount)
} else {
  watch(() => filtersStore.unsavedFilters, loadLpuCount)
}

const isActiveButton = computed(() => Boolean(filtersStore.hasUnsavedFilters && countLpu.value && !loading.value))

watch(isActiveButton, () => emit('input', isActiveButton.value))
</script>
